import { PropsWithChildren } from "react";
import { keyframes, styled } from "styled-components";

const blink = keyframes`
  50% { color: transparent }
`;

const Loader = styled.div`
  span {
    animation: 1s ${blink} infinite;
    &:nth-child(2) {
      animation-delay: 250ms;
    }
    &:nth-child(3) {
      animation-delay: 500ms;
    }
  }
`;

export const BlinkDots = ({ children }: PropsWithChildren) => {
  return (
    <Loader>
      {children}
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </Loader>
  );
};
